import { createStore, applyMiddleware, Store, AnyAction } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
// import logger from 'redux-logger';
import thunk from "redux-thunk";

import reducers from "./reducers";

// Define the state type - adjust this to match your actual root state
export type RootState = ReturnType<typeof reducers>;

// Create and export the store with proper typing
const store: Store<RootState, AnyAction> = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
